import protobuf from 'protobufjs';
import { getServiceUrl } from '../utils/api';

// Define the proto JSON structure inline to avoid loading external files
const protoDefinition = {
    nested: {
        admin: {
            nested: {
                AssignReviewerRequest: {
                    fields: {
                        case_id: { type: "string", id: 1 },
                        reviewer_id: { type: "string", id: 2 }
                    }
                },
                AssignReviewerResponse: {
                    fields: {}
                }
            }
        }
    }
};

const root = protobuf.Root.fromJSON(protoDefinition);
const AssignReviewerRequest = root.lookupType("admin.AssignReviewerRequest");
const AssignReviewerResponse = root.lookupType("admin.AssignReviewerResponse");

export const assignReviewer = async (
    caseId: string,
    reviewerId: string,
    accessToken: string | null,
    setAccessToken: (token: string | null) => void,
    logout: () => Promise<void> | void
): Promise<void> => {
    const requestPayload = {
        case_id: caseId,
        reviewer_id: reviewerId
    };

    const errMsg = AssignReviewerRequest.verify(requestPayload);
    if (errMsg) throw Error(errMsg);

    const message = AssignReviewerRequest.create(requestPayload);
    const buffer = AssignReviewerRequest.encode(message).finish();

    const apiUrl = getServiceUrl('adminservice', 'assignreviewer');

    if (!accessToken) {
        await logout();
        throw new Error("No access token available");
    }

    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-protobuf',
            'Authorization': `Bearer ${accessToken}`
        },
        body: buffer as any
    });

    if (response.status === 401) {
        await logout();
        throw new Error("Session expired. Please login again.");
    }

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to assign reviewer: ${response.status} ${response.statusText} - ${errorText}`);
    }
};
